import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { formatPrice } from "../lib/currency";
import { useAuth } from "./AuthContext";

const CurrencyContext = createContext(null);

export const CurrencyProvider = ({ children }) => {
  const { user } = useAuth();
  const [rates, setRates] = useState({ USD: 1 });
  const [symbols, setSymbols] = useState({ USD: "$" });
  const [currency, setCurrencyState] = useState("USD");

  useEffect(() => {
    api.get("/currency/rates")
      .then((res) => {
        setRates(res.data.rates || { USD: 1 });
        setSymbols(res.data.currencies || { USD: "$" });
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (user?.currency) setCurrencyState(user.currency);
  }, [user]);

  const setCurrency = useCallback(async (cur) => {
    setCurrencyState(cur);
    try {
      await api.post("/me/currency", { currency: cur });
    } catch {}
  }, []);

  const format = useCallback(
    (usd) => formatPrice(usd, currency, rates, symbols),
    [currency, rates, symbols]
  );

  const value = {
    currency,
    setCurrency,
    format,
    rates,
    symbols,
    rate: rates[currency] || 1,
    symbol: symbols[currency] ?? "$",
  };

  return <CurrencyContext.Provider value={value}>{children}</CurrencyContext.Provider>;
};

export const useCurrency = () => useContext(CurrencyContext);
